"use client"

import { useEffect, useState } from "react"

// How long the outgoing item gets to animate off before the index advances.
// Matches the .search-text-out timing in globals.css.
const EXIT_MS = 320

/** Index into a list that advances every `beatMs`, starting `offsetMs` into
 *  the bar, with an `exiting` window before each advance for the outro. */
export function useRotator(count: number, beatMs: number, offsetMs = 0) {
  const [index, setIndex] = useState(0)
  const [exiting, setExiting] = useState(false)
  useEffect(() => {
    if (count < 2) return
    let beat: ReturnType<typeof setInterval> | undefined
    let outro: ReturnType<typeof setTimeout> | undefined
    const swap = () => {
      setExiting(true)
      outro = setTimeout(() => {
        setIndex((i) => (i + 1) % count)
        setExiting(false)
      }, EXIT_MS)
    }
    // First swap lands at offsetMs into the bar; then once per bar.
    const lead = setTimeout(() => {
      swap()
      beat = setInterval(swap, beatMs)
    }, beatMs - EXIT_MS + offsetMs)
    return () => {
      clearTimeout(lead)
      if (beat) clearInterval(beat)
      if (outro) clearTimeout(outro)
    }
  }, [count, beatMs, offsetMs])
  return { index, exiting }
}
